import {
    defaultLanguages,
    CommonPlugin,
    type ZudokuConfig,
    ZudokuPlugin,
} from "zudoku";
import { createElement, Fragment } from "react";

// Custom plugin to hide the Zudoku footer
const hideFooterPlugin: ZudokuPlugin = {
    getHead: () =>
        createElement(
            "style",
            {},
            `
    /* Hide Zudoku footer */
    a[href*="zudoku.dev"] {
      display: none !important;
    }
    svg[viewBox="0 0 132 100"] {
      display: none !important;
    }
    div.bg-background.border-t.p-2.mx-5 {
      display: none !important;
    }
  `
        ),
};

const config: ZudokuConfig = {
    metadata: {
        title: "Cakemail API Documentation",
        description:
            "Cakemail API Documentation | Cakemail for Developers | Cakemail",
        logo: "/cakemail-logo-dark.svg",
        favicon: "/cakemail-favicon.ico",
        keywords: [
            "cakemail",
            "api",
            "documentation",
            "development",
            "developer",
        ],
        authors: ["Hans-David Giroux", "Sebastien Gregoire", "Cakemail"],
        creator: "Hans-David Giroux",
        publisher: "Cakemail Inc.",
    },
    plugins: [hideFooterPlugin],
    syntaxHighlighting: {
        languages: [...defaultLanguages],
    },
    redirects: [
        { from: "/", to: "/api/guides/getting-started-ng-api" },
        { from: "/api", to: "/api/guides/getting-started-ng-api" },
        { from: "/api/guides", to: "/api/guides/getting-started-ng-api" },
        { from: "/changelog", to: "/api/changelog" },
        { from: "/guides", to: "/api/guides/getting-started-ng-api" },
        { from: "/reference", to: "/api/reference/account" },
        { from: "/api/changelog", to: "/api/changelog/next-gen-api-v118" },
    ],
    page: {
        logo: {
            src: {
                dark: "/cakemail-logo-dark.svg",
                light: "/cakemail-logo-light.svg",
            },
            alt: "Cakemail Logo",
            width: "120px",
        },
        pageTitle: "",
    },
    topNavigation: [
        { id: "guides", label: "Guides" },
        { id: "api/reference", label: "API Reference" },
        { id: "api/changelog", label: "Changelog" },
        { id: "classicapi", label: "Classic API" },
    ],
    sidebar: {
        guides: [
            {
                type: "category",
                label: "Integration",
                items: [
                    "/api/guides/getting-started-ng-api",
                    "/api/guides/managing-your-contacts",
                    "/api/guides/sending-your-first-campaign",
                    "/api/guides/managing-your-users",
                    "/api/guides/using-templates",
                    "/api/guides/using-webhooks",
                    "/api/guides/getting-started-email-api",
                    "/api/guides/automating-your-emails",
                ],
                collapsed: false,
            },
            {
                type: "category",
                label: "Partners",
                items: [
                    "/api/guides/working-as-a-partner",
                    "/api/guides/login-to-cakemail-next-gen-from-inside-your-app",
                ],
                collapsed: false,
            },
            {
                type: "category",
                label: "Classic API",
                items: ["/api/guides/classic-api-compatibility"],
                collapsed: false,
            },
        ],
        changelog: [
            {
                type: "category",
                label: "Changelog",
                items: [
                    "/api/changelog/next-gen-api-v118",
                    "/api/changelog/next-gen-api-v117",
                    "/api/changelog/next-gen-api-v115",
                    "/api/changelog/next-gen-api-v114",
                    "/api/changelog/next-gen-api-v113",
                    "/api/changelog/next-gen-api-v112",
                    "/api/changelog/next-gen-api-v111",
                    "/api/changelog/next-gen-api-v110",
                    "/api/changelog/next-gen-api-v19",
                    "/api/changelog/next-gen-api-v18",
                    "/api/changelog/next-gen-api-v17",
                    "/api/changelog/next-gen-api-v16",
                    "/api/changelog/next-gen-api-v15",
                    "/api/changelog/next-gen-api-v14",
                    "/api/changelog/next-gen-api-v13",
                    "/api/changelog/next-gen-api-v12",
                    "/api/changelog/next-gen-api-v11",
                    "/api/changelog/next-gen-api-v10A",
                    "/api/changelog/next-gen-api-v10",
                ],
                collapsed: false,
            },
        ],
        classicapi: [
            {
                type: "category",
                label: "Classic API",
                items: ["/api/guides/classic-api-compatibility"],
            },
        ],
    },
    apis: {
        type: "file",
        input: ["apis/openapi-v1.18.json", "apis/openapi-v1.17.json"],
        navigationId: "api/reference",
        options: {
            disablePlayground: false,
            disableSidecar: false,
            showVersionSelect: "if-available",
            expandAllTags: true,
        },
    },

    docs: {
        files: "/pages/**/*.{md,mdx}",
    },
    search: {
        type: "pagefind",
        maxSubResults: 3,
        ranking: {
            termFrequency: 0.8,
            pageLength: 0.6,
            termSimilarity: 1.2,
            termSaturation: 1.2,
        },
    },
};

export default config;
